/** Neighborhood-scorecard value vocabularies -- the SSOT both the TYPE unions and the RUNTIME guards read.
 *
 *  Each member set was spelled TWICE before this leaf existed: once as a hand-written union in `types/places.ts` /
 *  `types/properties-neighborhood.ts`, and once as a literal `new Set([...])` inside the WebSocket property parser
 *  (`components/lib/websocket/parse.ts`), which is the only surface that gates an off-the-wire `locationData` payload against
 *  them. Two spellings of one decision: widening the union alone silently leaves the runtime guard rejecting the new
 *  member, and widening the guard alone lets a value the type forbids cross the boundary. The unions now DERIVE from
 *  these arrays and the guards CONSUME them, so a single edit here moves both. */

/** `CommuteDestination.travelMode` vocabulary -- the Google Directions travel modes the commute card requests. */
export const TRAVEL_MODES = ['driving', 'transit', 'walking', 'bicycling'] as const;

/** `WalkabilityMetrics.grade` vocabulary -- the letter scorecard, with no `E` (US grading convention). */
export const WALKABILITY_GRADES = ['A', 'B', 'C', 'D', 'F'] as const;
